import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useImperativeHandle, useState } from "react";
import { Form } from "antd";
import AddressPanel from "../../../components/AddressPanel";
import WaypointUhfChannelsCardFormItems from "./WaypointUhfChannelsCardFormItems";
import WaypointSaveAsSenderReceiverModal from "./WaypointSaveAsSenderReceiverModal";
const WaypointEditForm = ({ tenantId, title = 'Address', waypoint, readOnly = false, editContactsOnly = false, overwriteAddressOnGeolocate = true, contactNameRequired = false, contactPhoneRequired = false, allowSaveAsSenderReceiver = true, onSiteRadiusChanged, onLocationChanged, onSavedAsSenderReceiver }, exportedRef) => {
    const [form] = Form.useForm();
    const [saveAsSenderReceiverUpdateRequest, setSaveAsSenderReceiverUpdateRequest] = useState(undefined);
    useImperativeHandle(exportedRef, () => ({
        validateFields: () => form.validateFields()
    }));
    const buildSaveAsSenderReceiver = (formValues) => {
        const request = {
            tenantId: tenantId,
            companyName: formValues.companyName,
            contactName: formValues.contactName,
            contactTelephone: formValues.contactTelephone,
            contactEmail: formValues.contactEmail,
            uhfChannelOffice: formValues.uhfChannelOffice,
            uhfChannelLoader: formValues.uhfChannelLoader,
            disable: false,
            address: {
                unitOrFlat: formValues.unitOrFlat,
                street: formValues.street,
                suburb: formValues.suburb,
                state: formValues.state,
                postcode: formValues.postcode,
                countryCode: formValues.countryCode,
                latitude: waypoint?.address?.latitude,
                longitude: waypoint?.address?.longitude,
                siteRadius: waypoint?.address?.siteRadius,
            }
        };
        setSaveAsSenderReceiverUpdateRequest(request);
    };
    const onSaveAsSenderReceiverClicked = () => {
        form.validateFields()
            .then(buildSaveAsSenderReceiver)
            .catch(console.error); // This has to be present otherwise antd crashes :(
    };
    const hideSaveAsSenderReceiverModal = () => {
        setSaveAsSenderReceiverUpdateRequest(undefined);
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Form, { layout: "vertical", form: form, children: [_jsx(AddressPanel, { form: form, title: title, waypoint: waypoint, readOnly: readOnly, editContactsOnly: editContactsOnly, overwriteAddressOnGeolocate: overwriteAddressOnGeolocate, contactNameRequired: contactNameRequired, contactPhoneRequired: contactPhoneRequired, showMapAlways: true, showStatus: true, onSaveAsSenderReceiverClicked: allowSaveAsSenderReceiver ? onSaveAsSenderReceiverClicked : undefined, showCompanyContactDetails: true, onSiteRadiusChanged: onSiteRadiusChanged, onLocationChanged: onLocationChanged }), _jsx(WaypointUhfChannelsCardFormItems, { initialUhfChannelOffice: waypoint?.uhfChannelOffice, initialUhfChannelLoader: waypoint?.uhfChannelLoader })] }), _jsx(WaypointSaveAsSenderReceiverModal, { tenantId: tenantId, senderReceiver: saveAsSenderReceiverUpdateRequest, open: !!saveAsSenderReceiverUpdateRequest, onCancel: hideSaveAsSenderReceiverModal, onSave: sr => {
                    hideSaveAsSenderReceiverModal();
                    onSavedAsSenderReceiver(sr);
                } })] }));
};
export default React.forwardRef(WaypointEditForm);
